import { render, staticRenderFns } from "./EnterpriseLink.vue?vue&type=template&id=524a38c5&"
import script from "./EnterpriseLink.vue?vue&type=script&lang=js&"
export * from "./EnterpriseLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports